import { createSelector } from '@reduxjs/toolkit';

// ═══════════════════════════════════════════════════════════
//  BASE SELECTOR
// ═══════════════════════════════════════════════════════════
const selectAdminState = (state) => state.admin ?? {};

// ═══════════════════════════════════════════════════════════
//  AUTH SELECTORS (mémorisés)
// ═══════════════════════════════════════════════════════════
export const selectIsAuthenticated = createSelector(
  [selectAdminState],
  (admin) => admin.isAuthenticated ?? false
);

export const selectAdminUser = createSelector(
  [selectAdminState],
  (admin) => admin.admin ?? null
);

export const selectAuthStatus = createSelector(
  [selectAdminState],
  (admin) => admin.authStatus ?? 'idle'
);

export const selectAuthError = createSelector(
  [selectAdminState],
  (admin) => admin.authError ?? null
);

// ═══════════════════════════════════════════════════════════
//  DOCTORS SELECTORS (mémorisés)
// ═══════════════════════════════════════════════════════════
// export const selectDoctors = createSelector(
//   [selectAdminState],
//   (admin) => admin.items ?? []
// );

export const selectDoctors = createSelector(
  [selectAdminState],
  (admin) => {
    return admin.items ?? [];
  }
);

export const selectDoctorsCount = createSelector(
  [selectAdminState],
  (admin) => admin.total ?? 0
);

export const selectDoctorCurrent = createSelector(
  [selectAdminState],
  (admin) => admin.current ?? null
);

export const selectDoctorStats = createSelector(
  [selectAdminState],
  (admin) => admin.stats ?? null
);

export const selectDoctorsStatus = createSelector(
  [selectAdminState],
  (admin) => admin.status ?? 'idle'
);

export const selectDoctorsError = createSelector(
  [selectAdminState],
  (admin) => admin.error ?? null
);

// ═══════════════════════════════════════════════════════════
//  DERIVED SELECTORS (factories)
// ═══════════════════════════════════════════════════════════
export const makeSelectDoctorById = (id) =>
  createSelector(
    [selectDoctors],
    (items) => items.find((d) => String(d.id) === String(id)) ?? null
  );

export const makeSelectDoctorsByStatus = (uiStatus) =>
  createSelector(
    [selectDoctors],
    (items) => items.filter((d) => d.status === uiStatus)
  );

// ═══════════════════════════════════════════════════════════
//  COMPUTED SELECTORS (exemples optionnels)
// ═══════════════════════════════════════════════════════════
export const selectPendingDoctors = createSelector(
  [selectDoctors],
  (items) => items.filter((d) => d.status === 'pending')
);

export const selectConfirmedDoctors = createSelector(
  [selectDoctors],
  (items) => items.filter((d) => d.status === 'confirmed')
);

export const selectRejectedDoctors = createSelector(
  [selectDoctors],
  (items) => items.filter((d) => d.status === 'rejected')
);

export const selectDoctorsCountByStatus = createSelector(
  [selectDoctors],
  (items) => ({
    pending: items.filter((d) => d.status === 'pending').length,
    confirmed: items.filter((d) => d.status === 'confirmed').length,
    rejected: items.filter((d) => d.status === 'rejected').length,
    total: items.length,
  })
);

export const selectFeedbacks = createSelector(
  [selectAdminState],
  (admin) => admin.feedbacks ?? []
);

export const selectFeedbackTotal = createSelector(
  [selectAdminState],
  (admin) => admin.feedbackTotal ?? 0
);

export const selectFeedbackCurrent = createSelector(
  [selectAdminState],
  (admin) => admin.feedbackCurrent ?? null
);

export const selectFeedbackAverage = createSelector(
  [selectAdminState],
  (admin) => admin.feedbackAverage ?? null
);

export const selectFeedbackStatus = createSelector(
  [selectAdminState],
  (admin) => admin.feedbackStatus ?? "idle"
);

export const selectFeedbackError = createSelector(
  [selectAdminState],
  (admin) => admin.feedbackError ?? null
);